(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uc-frequently-bought-together-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('uc-fbt-block')) {
    class UcFbtProductBlock extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.pistolSelect = this.querySelector('[data-pistol-select]');
        this.button = this.querySelector('[data-add-bundle]');
        this.status = this.querySelector('[data-status]');
        if (!this.pistolSelect || !this.button) return;
        this.pistolSelect.addEventListener('change', () => this.sync());
        this.button.addEventListener('click', () => this.addBundle());
        this.sync();
      }

      selectedOption() {
        return this.pistolSelect.options[this.pistolSelect.selectedIndex];
      }

      sync() {
        const option = this.selectedOption();
        if (!option.dataset.image) return;
        this.querySelectorAll('[data-pistol-image]').forEach((image) => {
          image.src = option.dataset.image;
          image.removeAttribute('srcset');
        });
      }

      rootUrl() {
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
        return root.endsWith('/') ? root : `${root}/`;
      }

      async fetchCart() {
        const response = await fetch(`${this.rootUrl()}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('The cart could not be refreshed.');
        return response.json();
      }

      async applyDiscountCode(code) {
        if (!code) return this.fetchCart();
        const response = await fetch(`${this.rootUrl()}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ discount: code })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || 'The bundle discount could not be applied.');
        return cart;
      }

      updateCartCounts(cart) {
        document.querySelectorAll('[data-cart-count]').forEach((element) => {
          element.textContent = cart.item_count || 0;
        });
        document.querySelectorAll('[data-cart-text]').forEach((element) => {
          element.textContent = cart.item_count === 1 ? 'item' : 'items';
        });
      }

      async refreshDrawer(cart) {
        const target = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (target) {
          const response = await fetch(`${this.rootUrl()}cart?view=ajax_side_cart`, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (response.ok) {
            const html = await response.text();
            if (html) target.innerHTML = html;
          }
        } else if (typeof window.refreshCartDrawer === 'function') {
          await Promise.resolve(window.refreshCartDrawer());
        }
        this.updateCartCounts(cart);
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        document.dispatchEvent(new CustomEvent('uc:cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('uc:cart:refresh', { detail: cart }));
      }

      async openDrawer(cart) {
        const drawer = document.querySelector('#halo-cart-sidebar');
        let opened = false;
        if (typeof window.openCartDrawer === 'function') {
          await Promise.resolve(window.openCartDrawer());
          opened = true;
        }
        if (drawer) {
          document.body.classList.add('cart-sidebar-show', 'uc-cart-drawer-open');
          drawer.hidden = false;
          drawer.removeAttribute('hidden');
          drawer.setAttribute('aria-hidden', 'false');
          opened = true;
        }
        document.dispatchEvent(new CustomEvent('uc:cart:open', { detail: cart }));
        if (!opened) throw new Error('The bundle was added, but the sliding cart could not be opened.');
      }

      async addBundle() {
        if (this.button.getAttribute('aria-busy') === 'true') return;
        const option = this.selectedOption();
        const caseQuantity = Number(this.dataset.caseQuantity) || 3;
        const rangeVariantId = Number(this.dataset.rangeVariantId);
        const bundleId = `uc-range-set-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const originalText = this.button.textContent;
        const properties = {
          Bundle: `${caseQuantity} Pistol Cases + ${this.dataset.bundleName || 'Range Bag'}`,
          _uc_bundle_id: bundleId
        };

        this.button.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.button.textContent = 'Adding…';
        this.status.dataset.error = 'false';
        this.status.textContent = '';

        try {
          const response = await fetch(`${this.rootUrl()}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [
                { id: Number(option.value), quantity: caseQuantity, properties },
                { id: rangeVariantId, quantity: 1, properties }
              ]
            })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'The bundle could not be added.');

          let cart;
          try {
            cart = await this.applyDiscountCode((this.dataset.discountCode || '').trim());
          } catch (discountError) {
            cart = await this.fetchCart();
          }

          this.status.textContent = 'Bundle added.';
          await this.refreshDrawer(cart);
          await this.openDrawer(cart);
        } catch (error) {
          this.status.dataset.error = 'true';
          this.status.textContent = error.message || 'Something went wrong. Please try again.';
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          this.button.textContent = originalText;
        }
      }
    }

    customElements.define('uc-fbt-block', UcFbtProductBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
